<template>
    <div class="container page">
        <div class="header">
            <van-nav-bar :title="$t('Membership Card')" class="nav-bar">
                <template #left>
                    <van-icon name="arrow-left" color="#fff" @click="back()" />
                </template>
            </van-nav-bar>
        </div>
        <div class="img-row">
            <img :src="vip_card" alt="">
        </div>
        <div class="vip img-row m-f-col m-f-center m-f-top" ref="myVip" v-if="userInfo.level">
            <p class="name">{{ userInfo.name }}</p>
            <p class="num m-flex"><span>{{ $t('vip Num') }}:</span><span class="num-text">{{ userInfo.level.levelsn
            }}</span>
            </p>
            <div class="status">
                <p v-if="userInfo.status*1==1">
                    {{userInfo.auth_status*1==1 ? $t('Certified') : $t('Unauthenticated') }}
                </p>
                <p v-else>{{ $t('Frozen') }}</p>
            </div>
            <img :src="userInfo.base64" alt="">
        </div>
        <div class="btn" @click="downVip">{{ $t('Download') }}</div>
    </div>

</template>

<script>
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            userInfo: {},
            vip_card: ''
        };
    },
    methods: {
        getUserInfo() {
            this.$http({
                method: 'get',
                url: 'user_info',
                data: {
                    type: 1
                }
            }).then(res => {
                if (res.code === 200) {
                    this.userInfo = res.data;
                    setTimeout(() => {
                    this.vipCard()
                    }, 500);
                    this.menu_top = 15;
                    /* if (this.userInfo.status !== 1) {
                        this.$toast(this.$t("video.account_out"));
                        localStorage.clear()
                        this.$router.push({
                            path: '/Login'
                        })
                    } */
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
        vipCard() {
            const img = this.$refs.myVip,
                width = img.offsetWidth,
                height = img.offsetHeight,
                scale = 2
            html2canvas(img, {
                width,
                height,
                backgroundColor: 'transparent',
                dpi: window.devicePixelRatio * 2,
                scale,
                x: 0,
                y: 0,
                scrollX: -3,
                scrollY: -10,
                useCORS: true,
                allowTaint: true
            }).then(canvas => {
                let url = canvas.toDataURL()
                this.vip_card = url
            })
        },
        downVip() {
            let a = document.createElement('a')
            a.download = 'vip'
            let event = new MouseEvent('click')
            a.href = this.vip_card
            a.dispatchEvent(event)
        },
        back() {
            return window.history.back();
        }
    },
    created() {
        this.getUserInfo()
    }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";

.btn {
    padding: @pd1;
    margin: @md1 auto;
    width: 80%;
    background: linear-gradient(-45deg, @btn1, @btn2);
    border-radius: 10em;
    text-align: center;
}

.vip {
    position: fixed;
    top: 200%;
    margin: @md1;
    color: @theme2;
    width: 500px;

    .name,
    .num,
    .status {
        position: absolute;
    }

    .name {
        top: 35px;
        left: 80px;
        width: 150px;
        font-size: 12px;
        color: @white;
        text-align: center;
    }

    @vip_color: #b25c43;

    .num {
        display: inline-block;
        bottom: 25px;
        left: 72px;
        font-size: 12px;
        width: 150px;
        text-align: center;
        .num-text {
            color: @vip_color;
        }
    }

    .status {
        right: 10px;
        bottom: 25px;
        width: 115px;
        font-size: 14px;
        text-align: center;
        color: @vip_color;
    }

    p {
        margin: 0;
    }
}
</style>